module.exports = "/_next/static/images/401-15750df7413e7f89048f29ea87ee64b9.svg";